import InfoIcon from '@mui/icons-material/Info';
import React from 'react';

import { FooterText } from '../footer-text/FooterText';

export const CelticBankDisclaimer: React.FC = () => {
  const disclaimer =
    'The Coast Visa® Commercial Card is issued by Celtic Bank. All card accounts subject to credit approval.';

  return <FooterText icon={<InfoIcon fontSize="small" />} text={disclaimer} />;
};
